var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00006 17.0566C5.00006 17.7197 5.26345 18.3556 5.73229 18.8244C6.20114 19.2932 6.83702 19.5566 7.50006 19.5566C8.1631 19.5566 8.79899 19.2932 9.26783 18.8244C9.73667 18.3556 10.0001 17.7197 10.0001 17.0566C10.0001 16.3936 9.73667 15.7577 9.26783 15.2889C8.79899 14.82 8.1631 14.5566 7.50006 14.5566C6.83702 14.5566 6.20114 14.82 5.73229 15.2889C5.26345 15.7577 5.00006 16.3936 5.00006 17.0566Z",
    stroke: "#808187",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 14.834C13.3334 15.497 13.5968 16.1329 14.0657 16.6018C14.5345 17.0706 15.1704 17.334 15.8334 17.334C16.4965 17.334 17.1324 17.0706 17.6012 16.6018C18.07 16.1329 18.3334 15.497 18.3334 14.834C18.3334 14.1709 18.07 13.5351 17.6012 13.0662C17.1324 12.5974 16.4965 12.334 15.8334 12.334C15.1704 12.334 14.5345 12.5974 14.0657 13.0662C13.5968 13.5351 13.3334 14.1709 13.3334 14.834Z",
    stroke: "#808187",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 17.0556C10.0001 13.6927 10.0001 6.22222 10.0001 6.22222L18.3334 4V14.8333",
    stroke: "#808187",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72235 9.55621L18.6112 7.33398",
    stroke: "#808187",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSound);
export default __webpack_public_path__ + "static/media/ic_sound.7169bf8f5d84962018c592cf26b7b5c1.svg";
export { ForwardRef as ReactComponent };